export class MaskImpl {

    protected prevValueLengh: number = 0;

    protected target: HTMLInputElement;

    public setTarget(target: HTMLInputElement): void {
        this.target = target;
    }

    public execute() {
        this.init();
    }

    public init() {
        let thisGlobal = this;
        this.prevValueLengh = this.target.value.length;
        this.target.addEventListener('input', () => {
            thisGlobal.onChangeValueHandler();
        }, false);
        this.target.addEventListener('focus', () => {
            thisGlobal.prevValueLengh = (thisGlobal.target.value || '').length;
        }, false);
    }

    public getSelectionStart() {
        try {
            let cSelStart = this.target.selectionStart.toString();
            return parseInt(cSelStart);
        } catch (e) {}
    };


    public setCursorPosition(pos: number) {
        try {
            if (this.target.setSelectionRange) {
                this.target.setSelectionRange(pos, pos);
            }
        } catch (e) {}
    }


    public onChangeValueHandler() {
        let thisGlobal = this;
        var cursorPosition = thisGlobal.getSelectionStart();
        var value = this.target.value;
//        if (!value) {
//            return value;
//        }
        value = thisGlobal.normalize(value || '');

        var prevCursorPosition = cursorPosition - 1 < 0 ? 0 : cursorPosition - 1;
        if (!/^[0-9]$/.test(value[prevCursorPosition])) {
            if (thisGlobal.prevValueLengh <= value.length) {
                cursorPosition++;
            } else {
                cursorPosition--;
            }
        }

        setTimeout(function () {
            thisGlobal.setCursorPosition(cursorPosition);
        }, 0);
        thisGlobal.prevValueLengh = (value || '').length;
        // Меняеем только в случае если изменилось
        if (this.target.value !== value) {
            this.target.value = value;
        }
    }

    public normalize(value: string): string {
        return value;
    }

}
